export const environment = {
  production: false,
  appUrl: 'https://signup.dev.superyes.com',
  supabaseUrl: 'https://gnpeicbvorawpurtmuwy.supabase.co',
  supabaseKey: 'sb_publishable_6FIFeLCtEzA7zyVofsyHmw_b3WhUl25',
  googleMapsApiKey: 'AIzaSyDhy0F1Yr-LghqcXgfOoLiO-3I-5UOk72g',
  serviceManagerUrl: 'https://service-aggregator.int-dev-aks.cordiccloud.com/api/new-customer/application-submitted',
  serviceManagerApiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InVhU0o3aXlRS2l1ZmkxVWFJQkxsRDZWeWNGWSJ9.eyJzdWIiOiIyMTM2ODAiLCJuYW1lIjoiQ29yZGljIFRlY2hub2xvZ2llcyBMdGQiLCJhZG1pbiI6dHJ1ZSwiaWF0IjoxNTE2MjM5MDIyfQ.gNZ5A3UeYN3uWfU2tUYYumYDV3PonllbknM85j3mSTc',
};
